// extracted by mini-css-extract-plugin
module.exports = {"wrap":"cp-z","heading":"dp-z","brandPromo":"ep-z"};